// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // Tuition Management dev build: one build for every brand, pointed at the Dev-Orbit API.
  apiUrl: '/',
  envName: 'dev',
  // Orbit TMS for this tier's Orbit twin (dev): the Programme overview links an order at /orders/edit/{orderCode}.
  orbitTmsUrl: 'https://orbit-tms-dev.supportingeducation.com',
  localDev: true,
  ssoDefaultEntry: false,
  leapGtmId: 'GTM-5G4LVNGG',
  // Entra SSO (the always-shown /signmein MSAL button) points at the SEG External Clients tenant
  // (b3e1b53d), not the corporate one. Dev deliberately shares UAT's 'LEAP V2 UAT' app reg rather than having its own: its SPA
  // redirect URIs cover leap-dev and tuition-dev alongside the two UAT hosts. Consent or redirect
  // changes on that registration therefore affect both environments.
  directoryId: 'b3e1b53d-148e-4991-9955-8b0809a6f0a7',
  applicationId: 'fa0605ff-de60-4ff7-8294-837f7b9c35a5',
  adalApiEndpoints: {},
  apiSecret: '309a63dd-0cb2-47d8-bff2-de48da8d20d6', // TODO: confirm TP API secret
  apiKey: '594c7a48-2abb-4d22-bc0e-588d5867f090', // TODO: confirm TP API key
  automationLoginKey: '694e650b-6b68-456c-8bed-331b42b34811', // TODO: confirm TP automation login key
  appInsightsConnectionString: 'InstrumentationKey=4e8bd96a-50c6-4b4f-a49c-2fbb3687d885;IngestionEndpoint=https://ukwest-0.in.applicationinsights.azure.com/;LiveEndpoint=https://ukwest.livediagnostics.monitor.azure.com/;ApplicationId=c7793a1f-1f0e-4f37-9b78-f3375ff178f1',
  appInsightsRoleName: 'Leap'
};
